var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      attrs: {
        width: 70,
        "footer-hide": true,
        title: "禁售区域设置",
        "class-name": "vertical-center-modal",
      },
      on: { "on-visible-change": _vm.onShowChange },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c(
        "Card",
        { attrs: { padding: 0, bordered: false, "dis-hover": true } },
        [
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "Form",
                    {
                      staticClass: "small-form",
                      attrs: { "label-position": "top" },
                    },
                    [
                      _c(
                        "Row",
                        { attrs: { gutter: 16 } },
                        [
                          _c(
                            "Col",
                            { attrs: { span: "6" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "省份" } },
                                [
                                  _c(
                                    "Select",
                                    {
                                      attrs: { filterable: "" },
                                      on: { "on-change": _vm.onProvinceChange },
                                      model: {
                                        value: _vm.form.provinceUuid,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "provinceUuid",
                                            $$v
                                          )
                                        },
                                        expression: "form.provinceUuid",
                                      },
                                    },
                                    _vm._l(
                                      _vm.provinceOptions,
                                      function (item) {
                                        return _c(
                                          "Option",
                                          {
                                            key: item.regionUuid,
                                            attrs: { value: item.regionUuid },
                                          },
                                          [_vm._v(_vm._s(item.regionName))]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "6" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "城市" } },
                                [
                                  _c(
                                    "Select",
                                    {
                                      attrs: { filterable: "" },
                                      on: { "on-change": _vm.onCityChange },
                                      model: {
                                        value: _vm.form.cityUuid,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "cityUuid", $$v)
                                        },
                                        expression: "form.cityUuid",
                                      },
                                    },
                                    _vm._l(_vm.cityOptions, function (item) {
                                      return _c(
                                        "Option",
                                        {
                                          key: item.regionUuid,
                                          attrs: { value: item.regionUuid },
                                        },
                                        [_vm._v(_vm._s(item.regionName))]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "6" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "区域" } },
                                [
                                  _c(
                                    "Select",
                                    {
                                      attrs: { filterable: "" },
                                      model: {
                                        value: _vm.form.distUuid,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "distUuid", $$v)
                                        },
                                        expression: "form.distUuid",
                                      },
                                    },
                                    _vm._l(_vm.distOptions, function (item) {
                                      return _c(
                                        "Option",
                                        {
                                          key: item.regionUuid,
                                          attrs: { value: item.regionUuid },
                                        },
                                        [_vm._v(_vm._s(item.regionName))]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Col",
                            { attrs: { span: "4" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: " " } },
                                [
                                  _c(
                                    "Button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.onAddBlock },
                                    },
                                    [_vm._v("添加")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c("Table", {
                    ref: "mainTable",
                    attrs: {
                      size: "small",
                      columns: _vm.mainTable.columns,
                      data: _vm.blockDistList,
                      "highlight-row": "",
                      stripe: "",
                      border: "",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }